import * as Scrivito from "scrivito"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const ProductGroupObjClass = Scrivito.provideObjClass("ProductGroup", {
  attributes: {
    title: "string",
    image: ["reference", { only: "Image" }],
    imageWidgets: ["widgetlist", { only: "ImageWidget" }],
    childOrder: "referencelist"
  },
  onlyChildren: ["Product"]
})

export type ProductGroupObj = InstanceType<typeof ProductGroupObjClass>
export type ProductGroupAttributes = ScrivitoAttributes<ProductGroupObj>
